import { render, staticRenderFns } from "./shopWalletLog.vue?vue&type=template&id=34387b9a&scoped=true&"
import script from "./shopWalletLog.vue?vue&type=script&lang=js&"
export * from "./shopWalletLog.vue?vue&type=script&lang=js&"
import style0 from "./shopWalletLog.vue?vue&type=style&index=0&id=34387b9a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34387b9a",
  null
  
)

export default component.exports